var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18539_54804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8094 8.14945C15.8094 7.49394 15.7562 7.01559 15.6411 6.51953H8.15576V9.47819H12.5495C12.4609 10.2135 11.9826 11.3208 10.9195 12.0648L10.9046 12.1639L13.2714 13.9973L13.4353 14.0137C14.9412 12.6229 15.8094 10.5766 15.8094 8.14945Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15558 15.9465C10.3081 15.9465 12.1152 15.2378 13.4352 14.0154L10.9194 12.0665C10.2462 12.536 9.34258 12.8638 8.15558 12.8638C6.04731 12.8638 4.25794 11.473 3.62007 9.55078L3.52658 9.55872L1.06563 11.4633L1.03345 11.5527C2.34447 14.1571 5.03742 15.9465 8.15558 15.9465Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.62011 9.54985C3.45181 9.05379 3.3544 8.52225 3.3544 7.97306C3.3544 7.4238 3.45181 6.89232 3.61126 6.39626L3.6068 6.29061L1.11501 4.35547L1.03349 4.39425C0.493151 5.47498 0.183105 6.6886 0.183105 7.97306C0.183105 9.25751 0.493151 10.4711 1.03349 11.5518L3.62011 9.54985Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15558 3.08269C9.65262 3.08269 10.6625 3.72934 11.2383 4.26974L13.4883 2.07286C12.1064 0.788397 10.3081 0 8.15558 0C5.03742 0 2.34447 1.78937 1.03345 4.39371L3.61122 6.39573C4.25794 4.47347 6.04731 3.08269 8.15558 3.08269Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18539_54804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6352,
    height: 16,
    fill: "white",
    transform: "translate(0.182373)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.63a51c28c4d1fa2df3e1d707982ab22d.svg";
export { ForwardRef as ReactComponent };